import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-[#0B0B1A] py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-112">
      {/* Background glows */}
      <div className="absolute top-1/3 right-0 w-[500px] h-[400px] bg-[#FF00FF] opacity-8 blur-[150px] rounded-full pointer-events-none" data-id="element-113" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[300px] bg-[#00D4FF] opacity-8 blur-[120px] rounded-full pointer-events-none" data-id="element-114" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-115">
        <h2 className="text-3xl md:text-5xl font-extrabold text-center text-white mb-12" data-id="element-116">
          Si usas internet todos los días, esto te interesa
        </h2>

        <div className="prose prose-lg md:prose-xl max-w-none text-gray-300 space-y-6" data-id="element-117">
          <p className="font-medium text-center text-2xl text-white" data-id="element-118">
            Hoy nuestra vida está conectada a internet.
          </p>

          <p className="text-center text-gray-400" data-id="element-119">
            Usamos nuestras cuentas para:
          </p>

          <div className="bg-white/5 p-6 rounded-xl border border-white/10 max-w-2xl mx-auto" data-id="element-120">
            <ul className="space-y-3 font-medium text-gray-200" data-id="element-121">
              <li className="flex items-center gap-3" data-id="element-122">
                <span className="text-[#00D4FF] text-2xl" data-id="element-123">•</span> hablar con
                amigos
              </li>
              <li className="flex items-center gap-3" data-id="element-124">
                <span className="text-[#00D4FF] text-2xl" data-id="element-125">•</span> manejar
                negocios
              </li>
              <li className="flex items-center gap-3" data-id="element-126">
                <span className="text-[#00D4FF] text-2xl" data-id="element-127">•</span> pagar
                servicios
              </li>
              <li className="flex items-center gap-3" data-id="element-128">
                <span className="text-[#00D4FF] text-2xl" data-id="element-129">•</span> guardar
                información personal
              </li>
            </ul>
          </div>

          <div className="bg-[#FF3333]/10 border-l-4 border-[#FF3333] p-6 my-10 rounded-r-xl" data-id="element-130">
            <p className="text-xl md:text-2xl font-bold text-white m-0" data-id="element-131">
              Pero hay algo que casi nadie nos enseñó:
              <br data-id="element-132" />
              <span className="text-[#FF3333]" data-id="element-133">
                👉 Cómo proteger nuestra vida digital.
              </span>
            </p>
          </div>

          <p className="text-center font-bold text-xl text-white" data-id="element-134">
            Por eso miles de personas pierden cada día:
          </p>

          <div className="flex flex-wrap justify-center gap-4 my-6" data-id="element-135">
            {[{
            text: 'su Instagram',
            color: 'from-[#E1306C] to-[#F77737]'
          }, {
            text: 'su Gmail',
            color: 'from-[#EA4335] to-[#FBBC05]'
          }, {
            text: 'su WhatsApp',
            color: 'from-[#25D366] to-[#128C7E]'
          }, {
            text: 'su negocio online',
            color: 'from-[#FF00FF] to-[#00D4FF]'
          }].map((item, i) => <motion.span key={i} initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className={`bg-gradient-to-r ${item.color} px-6 py-3 rounded-full font-extrabold text-white text-lg md:text-xl shadow-lg`} data-id="element-136">
                • {item.text}
              </motion.span>)}
          </div>

          <p className="text-center text-xl mt-10 text-gray-300" data-id="element-137">
            No porque los hackers sean genios.
            <br data-id="element-138" />
            <span className="font-bold text-2xl text-white" data-id="element-139">
              Sino porque la mayoría comete errores básicos de seguridad.
            </span>
          </p>

          <p className="text-center mt-6 text-gray-400" data-id="element-140">Como por ejemplo:</p>

          <div className="bg-white/5 p-6 md:p-8 rounded-xl border border-red-500/20 max-w-2xl mx-auto" data-id="element-141">
            <ul className="space-y-4" data-id="element-142">
              <li className="flex items-start gap-3" data-id="element-143">
                <span className="text-2xl" data-id="element-144">❌</span>
                <span className="text-lg font-medium text-gray-200" data-id="element-145">
                  usar la misma contraseña en todo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-146">
                <span className="text-2xl" data-id="element-147">❌</span>
                <span className="text-lg font-medium text-gray-200" data-id="element-148">
                  no activar verificación en dos pasos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-149">
                <span className="text-2xl" data-id="element-150">❌</span>
                <span className="text-lg font-medium text-gray-200" data-id="element-151">
                  hacer clic en enlaces falsos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-152">
                <span className="text-2xl" data-id="element-153">❌</span>
                <span className="text-lg font-medium text-gray-200" data-id="element-154">
                  compartir demasiada información en redes
                </span>
              </li>
            </ul>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mt-12" data-id="element-155">
            <p className="text-3xl md:text-4xl font-extrabold text-[#FF3333] uppercase tracking-wide" data-id="element-156">
              Cuando ocurre un ataque… ya es tarde.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}